<template>
  <div>
    <button type="submit" @click.prevent="visible=true" style="font-size:22px;background-color:#007bff;border-radius:2px;border:0px solid #fff;padding:12px 24px;color:#fff;font-weight:600;">Upgrade to Geofolio Pro</button>

    <div class="modal-mask" v-if="visible">
        <div v-on:click.self="upgradeStop" class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header" style="padding-bottom:0px;">
              <h2>Upgrade this factsheet to Geofolio <strong><span style="background-color:#84ba45;font-weight:600;color:#fff;padding:1px 4px;border-radius:3px;">Pro</span></strong></h2>
              <button type="button" class="btn btn-link" @click.prevent="upgradeStop" style="color:#666;position:relative;top:-7px;right:-10px;;font-size:1.3em;"><i class="bi bi-x-lg"></i></button>
            </div>
            <hr/>
            <div v-if="hasEnoughCredits" style="padding-bottom:15px;">
              <p style="padding-top:-px;">
                You can upgrade this factsheet to Geofolio Pro for <strong>1 credit</strong>. You currently have <strong>{{ profile.credits.credits_available_count }} credits</strong> available in your account. Also, please make sure the area of interest you have defined is correct, as this cannot be changed after upgrading!
              </p>
              <a :href="upgradeUrl" style="padding:10px 20px;font-size:20px;font-weight:600;margin-bottom:10px;" class="btn btn-primary">Upgrade Factsheet Now</a>
                <br/><span style="font-size:18px;font-weight:400;color:#888;">1 credit will be used for this upgrade.</span>
            </div>
            <div v-else  style="padding-bottom:0px;">
                <p style="padding-top:0px;">
                You do not have any credits in your account to upgrade factsheets. It is possible to upgrade only this factsheet for a one-time payment of <strong>EUR 25</strong>.
                </p>
                <a :href="upgradeUrl" style="padding:10px 20px;font-size:20px;font-weight:600;margin-bottom:10px;" class="btn btn-primary">Upgrade only this factsheet for EUR 25</a>
                <br/><span style="font-size:18px;font-weight:400;color:#888;">Clicking the button will redirect you to our payment provider</span>
                <hr />
                <p>
                You may also buy credits in bulk to upgrade multiple factsheets. You can purchase <strong>10 credits for EUR 200</strong> to <strong>upgrade 10 factsheets</strong>. The credits are non-refundable but valid indefinetely. You can use them to upgrade factsheets immediately without needing to pay every time.
                </p>
                <a href="/credits/add/10" style="padding:10px 20px;font-size:20px;font-weight:600;margin-bottom:10px;" class="btn btn-primary">Buy 10 credits for EUR 200</a>
                <br/><span style="font-size:18px;font-weight:400;color:#888;">Clicking the button will redirect you to our payment provider</span>
                </p>
            </div>

            <hr/>
            <p class="text-center">
              <a href="/docs/geofolio-pro/">Find out more about how Geofolio Pro works</a>
            </p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */


export default {
    name: 'UpgradeModal',
    props: ['factsheet', 'loaded'],
    data() {
      return {
        visible: false
      }
    },
    created() {
    },
    mounted() {
    },
    computed: {
        profile() {
          return this.getProfile();
        },
        hasEnoughCredits() {
          return this.profile.credits.credits_available_count > 0;
        },
        upgradeUrl() {
          return "/credits/upgrade/"+this.factsheet.identifier;
        }
    },
    filters: {
    },
    methods: {
      upgradeStop() {
        this.visible = false;
      },

    },
};
</script>


<style>
div.upgrade-body {
  border-top:1px solid #ddd;
  margin-top:4px;
  margin-bottom:5px;
  padding:5px 0px;

}
div.upgrade-body ul {
  margin-top:5px;
  margin-bottom:8px;
}
div.upgrade-body h1 {
  font-size:1.6em;
  padding:10px 10px 0px 10px;;
  font-weight:bold;
}
div.upgrade-body h2 {
  font-size:1.2em;
  padding:5px 10px 0px 10px;;
  font-weight:bold;
}
p {
  text-align:left;
}
</style>

<style scoped>


</style>
